import { takeEvery } from "redux-saga/effects";
import {
  createCourseAction,
  getAllCourseAction,
  getCourseLearningAction,
  getDetailsCourseAction,
  deleteCourseAction,
  addLectureAction,
  getDetailsCourseForUpdateAction,
  updateCourseAction,
  updateLectureAction,
  exploreCourseAction,
  getSavedCoursesAction,
  saveCourseAction,
  getMoreSavedCoursesAction,
  deleteSavedCourseAction,
  markLessonCompletedAction,
  deleteAllSavedCoursesAction,
  getAllCourseByInstructorAction,
  addAssignmentAction,
  getNewestCoursesAction,
  getHighestRatedCoursesAction,
  checkSavedCourseAction,
  changeCourseStatusAction,
  getAllMyLearningAction,
} from "./slices";
import {
  createCourseWorker,
  getAllCourseWorker,
  getCourseLearningWorker,
  getDetailsCourseWorker,
  deleteCourseWorker,
  addLectureWorker,
  getDetailsCourseForUpdateWorker,
  updateCourseWorker,
  updateLectureWorker,
  exploreCourseWorker,
  getSavedCoursesWorker,
  saveCourseWorker,
  getMoreSavedCoursesWorker,
  deleteSavedCourseWorker,
  markLessonCompletedWorker,
  deleteAllSavedCoursesWorker,
  getAllCourseByInstructorWorker,
  addAssignmentWorker,
  getNewestCoursesWorker,
  getHighestRatedCoursesWorker,
  checkSavedCourseWorker,
  changeCourseStatusWorker,
  getAllMyLearningWorker,
} from "./workers";

const courseWatcher = [
  takeEvery(getAllCourseAction, getAllCourseWorker),
  takeEvery(exploreCourseAction, exploreCourseWorker),
  takeEvery(getNewestCoursesAction, getNewestCoursesWorker),
  takeEvery(getHighestRatedCoursesAction, getHighestRatedCoursesWorker),
  takeEvery(createCourseAction, createCourseWorker),
  // takeEvery(addLectureAction, addLectureWorker),
  takeEvery(deleteCourseAction, deleteCourseWorker),
  takeEvery(getDetailsCourseAction, getDetailsCourseWorker),
  takeEvery(getDetailsCourseForUpdateAction, getDetailsCourseForUpdateWorker),
  takeEvery(getCourseLearningAction, getCourseLearningWorker),
  takeEvery(updateCourseAction, updateCourseWorker),
  // takeEvery(updateLectureAction, updateLectureWorker),
  takeEvery(getAllCourseByInstructorAction, getAllCourseByInstructorWorker),
  // takeEvery(addAssignmentAction, addAssignmentWorker),
  takeEvery(getAllMyLearningAction, getAllMyLearningWorker),
  // Saved courses
  takeEvery(getSavedCoursesAction, getSavedCoursesWorker),
  takeEvery(getMoreSavedCoursesAction, getMoreSavedCoursesWorker),
  takeEvery(saveCourseAction, saveCourseWorker),
  takeEvery(deleteSavedCourseAction, deleteSavedCourseWorker),
  takeEvery(deleteAllSavedCoursesAction, deleteAllSavedCoursesWorker),
  takeEvery(checkSavedCourseAction, checkSavedCourseWorker),

  // Lecture completed
  takeEvery(markLessonCompletedAction, markLessonCompletedWorker),

  // Manage course
  takeEvery(changeCourseStatusAction, changeCourseStatusWorker),
];

export default courseWatcher;
